import $ from "jquery";
import { isInt, isFloat, getHeaderHeight, forceFocus } from "./functions";

const $document = $(document);
const $header = $(".top-bar");
const $elToScroll = $("html, body");

$document.on("click", ".smoothscroll", function (event) {
  const $thisEl = $(this);
  let selector;
  if ($thisEl.attr("href") !== undefined) {
    event.preventDefault();
    selector = $thisEl.attr("href");
  } else if ($thisEl.data("selector") !== undefined) {
    selector = $thisEl.data("selector");
  } else {
    return;
  }

  let offset = 0;
  if ($thisEl.data("offset") !== undefined) {
    offset = $thisEl.data("offset");
  }

  let animationDuration = 500;
  if ($thisEl.data("animduration") !== undefined) {
    animationDuration = $thisEl.data("animduration");
  }

  let elToScroll = $elToScroll;
  if ($thisEl.data("eltoscroll") !== undefined) {
    elToScroll = $thisEl.data("eltoscroll");
  }

  smoothscroll(selector, offset, animationDuration, elToScroll).then(() =>
    $thisEl.trigger("smoothscroll:end")
  );
});

export const smoothscroll = (
  selector,
  offset = 0,
  animationDuration = 500,
  elToScroll = $elToScroll
) => {
  if (
    (isInt(offset) || isFloat(offset) || offset === "header") &&
    (isInt(animationDuration) || isFloat(animationDuration))
  ) {
    return new Promise((resolve, reject) => {
      let height;

      if (
        typeof selector === "string" ||
        typeof selector === "object" ||
        selector instanceof $
      ) {
        if (typeof selector === "string" || typeof selector === "object") {
          selector = $(selector);
        }
        try {
          height = selector.offset().top;
        } catch (e) {
          console.log(e);
          reject(e);
        }
      } else if (isInt(selector) || isFloat(selector)) {
        height = selector;
      } else {
        reject("smoothscroll:selector:bad_type");
      }

      if (
        typeof elToScroll === "string" ||
        typeof elToScroll === "object" ||
        elToScroll instanceof $
      ) {
        if (typeof elToScroll === "string" || typeof elToScroll === "object") {
          elToScroll = $(elToScroll);
        }
      } else {
        reject("smoothscroll:elToScroll:bad_type");
      }

      if (offset === "header") {
        let awaitForHeader = false;
        if (elToScroll.scrollTop() === 0) {
          elToScroll.scrollTop(1);
          if (new RegExp("height").test($header.css("transition"))) {
            awaitForHeader = true;
          }
        }
        if (awaitForHeader === true) {
          $header.one("transitionend", () =>
            scrollToHeight(
              height - getHeaderHeight(),
              animationDuration,
              elToScroll,
              selector
            ).then((message) => resolve(message))
          );
        } else {
          scrollToHeight(
            height - getHeaderHeight(),
            animationDuration,
            elToScroll,
            selector
          ).then((message) => resolve(message));
        }
      } else {
        scrollToHeight(
          height - offset,
          animationDuration,
          elToScroll,
          selector
        ).then((message) => resolve(message));
      }
    });
  }
};

const scrollToHeight = (height, animationDuration, elToScroll, elToFocus) => {
  if (isInt(height) || isFloat(height)) {
    return new Promise((resolve, reject) => {
      if (parseInt(elToScroll.scrollTop()) !== parseInt(height)) {
        elToScroll.stop().animate(
          {
            scrollTop: height,
          },
          animationDuration,
          () => {
            // elToFocus instanceof $ ? forceFocus(elToFocus) : '';
            resolve("smoothscroll:done");
          }
        );
      } else {
        // elToFocus instanceof $ ? forceFocus(elToFocus) : '';
        resolve("smoothscroll:done");
      }
    });
  }
};
